import { render, staticRenderFns } from "./singleSwiper.vue?vue&type=template&id=16631efb&scoped=true"
import script from "./singleSwiper.vue?vue&type=script&lang=ts"
export * from "./singleSwiper.vue?vue&type=script&lang=ts"
import style0 from "./singleSwiper.vue?vue&type=style&index=0&id=16631efb&prod&lang=less"
import style1 from "./singleSwiper.vue?vue&type=style&index=1&id=16631efb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16631efb",
  null
  
)

export default component.exports